import { useState } from "react";
import Slider from "react-slick";
import VideoModal from "./VideoModal";

export default function QuoteSlider({ className }) {
  const [videoId, setVideoId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openOverlay = (id) => {
    setVideoId(id);
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeOverlay = () => {
    setIsOpen(false);
    setVideoId(null);
    document.body.style.overflow = "auto";
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <section className={`bg-white ${className}`}>
        <Slider className="quote-slider" {...settings}>
          <div className="slide">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-md-5 col-lg-6 mb-5 mb-md-0">
                  <div
                    className="video-thumb"
                    onClick={() => openOverlay("9RUKdDfcAjU")}
                  >
                    <img
                      src="img/vidthumb-vernakay.webp"
                      className="img-fluid"
                      alt="Verna Kay"
                    />
                    <div className="play-btn">
                      <i className="fas fa-play" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>{" "}
                <div className="col-12 col-md-7 col-lg-5 offset-lg-1">
                  <div className="quote">
                    <p className="color-purple">
                      We have this common denominator that we're all here to
                      make sure our employees are paid for their value, and I've
                      made a lot of great friends.
                    </p>
                    <div className="citation">
                      <strong className="name color-purple">Verna Kay</strong>
                      <div className="position color-purple">
                        Vice President of Cultural Stewardship, On Tap Credit
                        Union
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="slide">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-12 col-md-5 col-lg-6 mb-5 mb-md-0">
                  <div
                    className="video-thumb"
                    onClick={() => openOverlay("blM_-Po8Bm4")}
                  >
                    <img
                      src="img/vidthumb-rosemaryosteen.webp"
                      className="img-fluid"
                      alt="Rosemary O'Steen"
                    />
                    <div className="play-btn">
                      <i className="fas fa-play" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-7 col-lg-5 offset-lg-1">
                  <div className="quote">
                    <p className="color-purple">
                      The networking, I think, is the key piece.
                    </p>
                    <div className="citation">
                      <strong className="name color-purple">
                        Rosemary O'Steen
                      </strong>
                      <div className="position color-purple">
                        Vice President of Human Resources, Argent Federal Credit
                        Union
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>

      <VideoModal isOpen={isOpen} videoId={videoId} onClose={closeOverlay} />
    </>
  );
}
